import api from '@/api'

const getCart = async () => {
  const result = await api.get('/api/cart/')
  
  return result
}

const getCoupons = async () => {
  const result = await api.get('/api/cart/coupon', { loading: false })

  return result
}

const getRedeemableCoupons = async () => {
  const result = await api.get('/api/cart/coupon/redeemable', { loading: false })

  return result
}

const getCouponHistory = async () => {
  const result = await api.get('/api/cart/coupon/history', { loading: false })

  return result
}

const addProduct = async (body) => {
  const result = await api.post('/api/cart/add_product', body)
  
  return result
}

const decreaseProduct = async (body) => {
  const result = await api.post('/api/cart/decrease_product', body)
  
  return result
}

const deleteProduct = async (body) => {
  const result = await api.post('/api/cart/delete_product', body)

  return result
}

const applyCoupon = async (body) => {
  const result = await api.post('/api/cart/apply_coupon', body, { loading: false })
  
  return result
}

const redeemCoupon = async (body) => {
  const result = await api.post('/api/cart/coupon/redeem', body, { loading: false })

  return result
}

const removeCoupon = async () => {
  const result = await api.post('/api/cart/remove_coupon', null, { loading: false })
  
  return result
}

const createOrder = async (body) => {
  const result = await api.post('/api/cart/create_order', body)

  return result
}

const createOrderFree = async (body) => {
  const result = await api.post('/api/cart/create_order_free', body)

  return result
}

export default {
  getCart,
  getCoupons,
  getRedeemableCoupons,
  getCouponHistory,
  addProduct,
  decreaseProduct,
  deleteProduct,
  applyCoupon,
  redeemCoupon,
  removeCoupon,
  createOrder,
  createOrderFree,
}
